import { forgotPassword } from './pages/forgotPassword';
import { geolocationDenied } from './pages/geolocationDenied';
import { login } from './pages/login';
import { validateToken } from './pages/validateToken';

export const pt = {
  pages: {
    login,
    forgotPassword,
    geolocationDenied,
    validateToken,
  },
  components: {
    languageSwitch: {
      label: 'Alterar idioma',
      pt: 'Português',
      en: 'Inglês',
      es: 'Espanhol',
    },
    servicesSelection: {
      title: 'Selecionar serviços',
      selectAtLeastOne: 'Selecione pelo menos um serviço',
      next: 'Próximo',
    },
    additionalFields: {
      title: 'Campos Adicionais',
      back: 'voltar',
      zipLabel: 'CEP',
      phoneLabel: 'Telefone',
      emailLabel: 'E-mail',
      next: 'Próximo',
      zipRequired: 'CEP é obrigatório!',
      phoneRequired: 'Telefone é obrigatório!',
      emailRequired: 'E-mail é obrigatório!',
    },
    bodyStep: {
      identificationBy: 'Identificação por {{validation}}',
      companyLabel: 'Empresa:',
      userLabel: 'Usuário:',
      signOut: 'Sair',
      versionLabel: 'Versão:',
      apiVersionLabel: 'Versão API:',
      providerLabel: 'Fornecido por:',
      stepMeta: 'Etapa {{current}} de {{total}}',
      back: 'Voltar',
    },
    summary: {
      title: 'Resumo do atendimento',
      openButton: 'Ver resumo',
      close: 'Fechar',
      analysisTypeLabel: 'Tipo de análise',
      analysisTypeCnh: 'CNH/Passaporte + foto',
      analysisTypeFace: 'Foto da face',
      analysisTypeData: 'Preenchimento de dados',
      analysisTypePj: 'Pessoa Jurídica',
      nameLabel: 'Nome',
      documentLabel: 'Documento',
      servicesLabel: 'Serviços selecionados',
      allServices: 'Todos os serviços contratados',
      findingsCount: 'Apontamentos encontrados neste serviço',
      outcomeFindings: 'Este serviço encontrou apontamentos',
      outcomeFailed: 'A consulta deste serviço falhou — resultado não apurado',
      outcomeClean: 'Este serviço não encontrou apontamentos',
      empty: 'Ainda não informado',
    },
    camera: {
      title: 'Foto',
      back: 'voltar',
      clear: 'LIMPAR',
      next: 'PRÓXIMO',
      uploadImage: 'UPLOAD DE IMAGEM',
      camera: 'CÂMERA',
      takePhoto: 'TIRAR FOTO',
    },
    choose: {
      title: 'Selecionar método de análise',
      back: 'voltar',
      photoOption: 'Análise por foto',
      cnhOption: 'Análise por foto da CNH/Passaporte',
      faceOption: 'Análise por foto da face',
      dataOption: 'Análise por Preenchimento de Dados',
    },
    flowChooser: {
      title: 'O que você precisa consultar?',
      pfTitle: 'Consultas Pessoa Física',
      pjTitle: 'Consultas Pessoa Jurídica',
      description:
        'Realize busca completa com base nas consultas previamente autorizadas por sua empresa',
      unavailable:
        'Opção disponível para contratação. Fale com o nosso time comercial.',
    },
    companyIdentification: {
      title: 'Dados da Empresa',
      back: 'voltar',
      documentLabel: 'CNPJ',
      documentPlaceholder: '00.000.000/0000-00',
      next: 'Consultar',
      documentInvalid: 'CNPJ inválido',
      requestFailed: 'Não foi possível concluir a consulta. Tente novamente.',
    },
    identification: {
      title: 'Dados Pessoais',
      back: 'voltar',
      nameLabel: 'Nome Completo',
      birthLabel: 'Data de nascimento',
      documentTypeLabel: 'Tipo do documento',
      documentNumberLabel: 'Número',
      next: 'Próximo',
      nameRequired: 'Nome é obrigatório!',
      birthRequired: 'Data de nascimento é obrigatório!',
      documentInvalid: 'Documento inválido',
    },
    instructions: {
      title: 'Instruções',
      back: 'voltar',
      next: 'Próximo',
      selfie: {
        faceVisible: 'Tire uma selfie com o rosto frontal e visível',
        goodLighting: 'Busque uma boa iluminação',
        removeAccessories: 'Remova adereços como óculos e chapéu',
        avoidRotation: 'Evite rotacionar a câmera do dispositivo',
      },
      document: {
        flatSurface: 'Apoie o documento em uma superfície plana',
        goodLighting: 'Busque uma boa iluminação',
        adjustFocus: 'Ajuste o foco para garantir a qualidade',
        avoidRotation: 'Evite rotacionar a câmera do dispositivo',
      },
    },
    result: {
      title: 'Resultado',
      fullName: 'Nome Completo',
      document: 'Documento',
      failureMessage: 'Houve uma falha na consulta. Tente novamente.',
      biometryLabel: 'Biometria facial',
      findingsOverview: {
        withServices: 'apontamento(s) encontrado(s) em:',
        total: 'apontamento(s) encontrado(s) nesta consulta.',
      },
      status: {
        recommended: 'SEM APONTAMENTOS',
        notRecommended: 'COM APONTAMENTOS',
        failed: 'FALHA',
      },
      process: {
        subject: 'Assunto',
        branch: 'Área',
        type: 'Tipo de processo',
        judgingBody: 'Expedido por',
        defendands: 'Réus',
        date: 'Data de expedição',
        status: 'Status',
        lawsuitNr: 'Número do processo',
        value: 'Valor da causa',
      },
      buttons: {
        returnToPlatform: 'Voltar à plataforma SGRLOC',
        tryAgain: 'Tentar novamente',
        backToStart: 'Voltar ao Início',
      },
    },
    resultDetails: {
      notInformed: 'Não informado',
      titles: {
        score: 'Score de crédito',
        dados_pj: 'Dados da empresa',
        validacao_pj: 'Situação cadastral',
      },
      score: {
        classLabel: 'Classe',
        pointsLabel: 'Pontuação',
        bandScalePf: 'faixas — pessoa física',
        bandScalePj: 'faixas — pessoa jurídica',
        restrictionsTitle: 'Restrições',
        debts: 'Débitos',
        protests: 'Protestos',
        checks: 'Cheques',
        recordsCount: '{{count}} registro(s)',
        incomePresumed: 'Renda presumida',
        revenueEstimated: 'Faturamento estimado',
        notProven: 'Estimativa do provedor, não comprovada',
        consultDate: 'Apurado em',
        disclaimer:
          'A pontuação é informativa: o apontamento depende só das restrições. Utilize-a exclusivamente como apoio no processo de decisão.',
      },
      company: {
        registrationSection: 'Dados cadastrais',
        corporateName: 'Razão social',
        tradeName: 'Nome fantasia',
        openingDate: 'Data de abertura',
        companyAge: 'Idade da empresa',
        companyAgeValue: '{{years}} ano(s)',
        registrationStatus: 'Situação cadastral',
        registrationStatusDate: 'Data da situação',
        size: 'Porte',
        legalNature: 'Natureza jurídica',
        cnae: 'CNAE',
        partners: 'Sócios',
        partnerSince: 'desde {{date}}',
        addresses: 'Endereços',
        phones: 'Telefones',
        phoneMobile: 'celular',
        phoneLandline: 'fixo',
        emails: 'E-mails',
      },
    },
    optIn: {
      title: 'Termos de Uso',
      checkboxText: 'Eu li e concordo com estes termos e condições',
      buttons: {
        accept: 'Aceitar',
        refuse: 'Recusar',
      },
    },
    faceTecCamera: {
      back: 'voltar',
      titleCaptured: 'Foto capturada',
      titleDefault: 'Foto',
      buttons: {
        clear: 'LIMPAR',
        next: 'PRÓXIMO',
        startCamera: 'INICIAR CÂMERA',
      },
      loadingCapture: 'Carregando a captura',
      capturedAlt: 'Foto capturada',
    },
    loading: {
      alt: 'Carregando...',
    },
    dropzone: {
      documentAlt: 'Imagem do documento',
      placeholder: 'Selecione seu documento',
      fileTooLarge: 'Tamanho máximo da imagem deve ser de 1Mb',
    },
    logos: {
      sgrLoc: 'Logo SGRLoc',
      swint: 'Logo Odeen',
    },
  },
};

export default pt;
